var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSolMilestone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 2H14V6H3L2 7V15L3 16H14V30H16V16H24.98L25.66 15.74L30.02 11.74V10.26L25.66 6.26L25 6H16V2ZM24.58 14H4V8H24.58L27.84 11L24.58 14ZM10 10H20V12H10V10Z",
    fill: "#0057D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSolMilestone);
export default __webpack_public_path__ + "static/media/icon-sol-milestone.372e34a42ec619cd45deb7497f70a959.svg";
export { ForwardRef as ReactComponent };